import theme from "@/theme";
import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";

export const styles = {
  selectedMarket: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "#F4F5F6",
    borderRadius: "24px",
    padding: "8px",
    height: "36px",
  } as SxProps<Theme>,

  selectedMarketIconWrapper: {
    width: 20,
    height: 20,
  },

  selectedMarketIcon: {
    width: "100%",
    height: "100%",
  },

  selectedMarketText: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#2A2D31",
  },

  selectedMarketCloseIcon: {
    width: 14,
    height: 14,
    color: "#2A2D31",
    opacity: 0.3,
  },

  marketItem: {
    marginRight: "38px",
    width: "100%",
    maxWidth: "341.5px",
    height: "54px",
    paddingY: "8px",
    paddingX: "12px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  } as SxProps<Theme>,

  marketItemIcon: {
    width: "40px",
    height: "40px",
  },

  marketItemContent: {
    marginLeft: "12px",
    display: "flex",
    flexDirection: "column",
  },

  marketItemName: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "145%",
    color: "#2A2D31",
  },

  marketItemExchanges: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "135%",
    letterSpacing: "0.5%",
    color: "#7D8690",
    marginTop: "2px",
  },

  checkboxBox: (checked: boolean): SxProps<Theme> => ({
    width: "18px",
    height: "18px",
    borderRadius: "5px",
    marginLeft: "12px",
    padding: "2px",
    ...(checked
      ? { backgroundColor: theme.palette.custom.mainBlue }
      : { border: "1px solid #7D8690" }),
  }),
};
